import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from '../Common.service';
import { RestApiService } from '../rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class TenderQuantityService implements OnInit {

  private get_elementData = "Tender/GetTenderElements";
  private postOrEdit_elementData = "Tender/InsertUpdateTenderElements";
  private get_Items = "Tender/GetTenderItems";
  private postOrEdit_Items = "Tender/InsertUpdateTenderItems"
  private insetConfigureDiscipline = "Tender/InsertUpdateTenderDiscElementItems";
  private getConfigureDiscipline = "Tender/GetTenderTenderDiscElementItems";
  private projectConfigureElement = "Tender/InsertUpdateProjectTenderElements";
  private projectConfigureItem = "Tender/InsertUpdateProjectTenderElementItems";
  private getprojectConfigureElement = "Tender/GetProjectDiscElement";
  private getprojectConfigureItem = "Tender/GetProjectDiscElementItems";
  private insertTender ="Tender/InsertUpdateProjectTenders";
  private InsertUpdateProjectTenderElementDetails  ="Tender/InsertUpdateProjectTenderElementDetails";
  private getProjectElement ="Tender/GetProjectTenderElementDetails";
  private getprojectTenderDetails ="Tender/GetProjectTenderDetails";
  private delete_tender ="Tender/DeleteTenderDetails";

  constructor(private restAPTService: RestApiService, public commonService: CommonService) { }

  ngOnInit() { }

  getElementDataToDp(): Observable<any> {
    let postData = { "tE_Id": 0 }
    return this.restAPTService.new_POST(this.get_elementData, postData);
  }

  insertTenderData(obj?:any): Observable<any>{
    return this.restAPTService.new_POST(this.insertTender, obj);
  }

  insertElementDetailsTenderData(obj?:any): Observable<any>{
    return this.restAPTService.new_POST(this.InsertUpdateProjectTenderElementDetails, obj);
  }


  getElementProjectConfigure(Val?:any): Observable<any> {    
    let obj :any;       
    if(!!Val){
      obj= { "project_Id": this.commonService.getProjectId(), "disc_Id": Val};
    }else{
     obj = { "project_Id": this.commonService.getProjectId(), "disc_Id": null, "tE_Id": null };
    }
    return this.restAPTService.new_POST(this.getprojectConfigureElement, obj);
  }

  getItemProjectConfigure(element?:any): Observable<any> { 
   let obj= {};
    if(!!element){
       obj = { "project_Id": this.commonService.getProjectId(), "disc_Id": element.disc_Id, "tE_Id": element.tE_Id};
    }else{
       obj = { "project_Id": this.commonService.getProjectId(), "disc_Id": null, "tE_Id": null, "tI_Id": null };
    }   
    return this.restAPTService.new_POST(this.getprojectConfigureItem, obj);
  }

 getProjectTenderElement(val:any): Observable<any> {
  return this.restAPTService.new_POST(this.getProjectElement, val);
 }
 
getProjectTenderDetails(val:any): Observable<any> {
  return this.restAPTService.new_POST(this.getprojectTenderDetails, val);
}

deleteTender(val:any):Observable<any>{
  let obj:any = {    
      "result": null,
      "successCode": 0,
      "successMessage": null,
      "t_Id": val    
  }
  return this.restAPTService.new_POST(this.delete_tender, obj);
}

PostOrEditElementDataToDp(obj: any): Observable<any> {
    let postData = {
      "tE_Id": obj.tE_Id,
      "tE_Description": obj.description,
      "active_Tag": obj.isActive,
      "member_Id": this.commonService.getLoggedInUserId()
    } 
    return this.restAPTService.new_POST(this.postOrEdit_elementData, postData);
  }

  getItemDataToDp(): Observable<any> {
    let postData = { "tE_Id": 0 }
    return this.restAPTService.new_POST(this.get_Items, postData);
  }

  getDiscElementItemData(): Observable<any> {
    let postData:any = { "tI_Id": null, "tE_Id": null, "active_Tag": null, "disc_DED_Id": null }
    return this.restAPTService.new_POST(this.getConfigureDiscipline, postData);
  }

  insetorPostOrEditItemDataToDp(obj: any): Observable<any> {
    if (obj.isActive == true) {
      obj.isActive = "yes";
    } else if (obj.isActive == false) {
      obj.isActive = "no";
    }
    let postData = {
      "tI_Id": obj.tI_Id,
      "tI_Description": obj.description,
      "active_Tag": obj.isActive,
      "member_Id": this.commonService.getLoggedInUserId()
    }
    return this.restAPTService.new_POST(this.postOrEdit_Items, postData);
  }

  InsetConfigureDiscipline(obj: any): Observable<any> { 
    let postData = {
      "tI_Id": obj.tI_Id,
      "tE_Id": obj.tE_Id,
      "disc_DED_Id": obj.disc_DED_Id,
      "active_Tag": obj.isActive,
      "member_Id": this.commonService.getLoggedInUserId()
    }  
    return this.restAPTService.new_POST(this.insetConfigureDiscipline, postData);
  }

  InsetConfigureProjectElement(obj: any): Observable<any> {
    return this.restAPTService.new_POST(this.projectConfigureElement, obj);
  }

  InsertConfigureProjectItem(obj: any): Observable<any> {
    return this.restAPTService.new_POST(this.projectConfigureItem, obj);
  }

}
